import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const initialState = {
  couponRedeemed: false,
  couponRedeemedContract: false,
  activeCoupons: null,
  codePromotions: null,
  validPromoCode: null,
  couponTypeCredit: false,
  couponTypeVolume: false,
  couponTypeStartingBonus: false,
  couponDiscountAmount: 0,
  couponVolumeAmount: 0,
  couponVolumeUnit: null,
  couponLimited: false,
  couponDuration: null,
  voucherItem: null,
  validatedBookablePromotionData: null,
  validatedBookablePromotion: null,
  promotionBookingUrl: null,
  errorMessage: null,
  promoCodeAutomatic: null,
  loading: false,
  genericCodesRedeemed: []
}

const kwkPromos = [
  11211,
  24108,
  13101,
  14007,
  14008,
  14009,
  25101,
  26107,
  26108,
  26109,
  15201,
  15202,
  27101,
  27102,
  27213, // BW 6 Monate 50% GG STAGE
  15513, // BW 6 Monate 50% GG INT
  27214, // BW 6 Monate 50% 5 GB STAGE
  15514, // BW 6 Monate 50% 5 GB INT
  27215, // BW 6 Monate 50% 15 GB STAGE
  15515, // BW 6 Monate 50% 15 GB INT
  25759, // BW 2 Monate 50% GG STAGE
  13705, // BW 2 Monate 50% GG INT
  27209, // BW 2 Monate 50% 5 GB STAGE
  15509, // BW 2 Monate 50% 5 GB INT
  27210, // BW 2 Monate 50% 15 GB STAGE
  15510 // BW 2 Monate 50% 15 GB INT
]
const PromoCodeModule = {
  namespaced: true,
  state: {
    promoCodeState: initialState,
    voucherConfig: null,
    promoIds: null,
    activationPromoCodeAutomatic: null
  },
  getters: {
    activeCoupons: state => {
      return state.promoCodeState.activeCoupons
    },
    couponRedeemed: (state, getters, rootState, rootGetters) => {
      if (state.promoCodeState.loading) {
        return false
      }
      return state.promoCodeState.couponRedeemed
    },
    couponRedeemedContract: (state, getters, rootState, rootGetters) => {
      return state.promoCodeState.couponRedeemedContract
    },
    codePromotions: state => {
      return state.promoCodeState.codePromotions
    },
    genericCodesRedeemed: state => {
      return state.promoCodeState.genericCodesRedeemed
    },
    validPromoCode: state => {
      return state.promoCodeState.validPromoCode
    },
    couponTypeCredit: state => {
      return state.promoCodeState.couponTypeCredit
    },
    couponTypeVolume: state => {
      return state.promoCodeState.couponTypeVolume
    },
    couponTypeStartingBonus: state => {
      return state.promoCodeState.couponTypeStartingBonus
    },
    couponDiscountAmount: state => {
      return state.promoCodeState.couponDiscountAmount
    },
    couponVolumeAmount: state => {
      return state.promoCodeState.couponVolumeAmount
    },
    couponVolumeUnit: state => {
      return state.promoCodeState.couponVolumeUnit
    },
    couponLimited: state => {
      return state.promoCodeState.couponLimited
    },
    couponDuration: state => {
      return state.promoCodeState.couponDuration
    },
    voucherItem: state => {
      return state.promoCodeState.voucherItem
    },
    validatedBookablePromotionData: state => {
      return state.promoCodeState.validatedBookablePromotionData
    },
    validatedBookablePromotion: state => {
      return state.promoCodeState.validatedBookablePromotion
    },
    promoCodeAutomatic: state => {
      return state.promoCodeState.promoCodeAutomatic
    },
    voucherConfig: state => {
      return state.voucherConfig
    },
    activationPromoCodeAutomatic: state => {
      return state.activationPromoCodeAutomatic
    },
    promoIds: state => {
      return state.promoIds
    },
    getErrorMessage: state => {
      return state.promoCodeState.errorMessage
    }
  },
  actions: {
    async saveAutomaticPromoCodeForActivation ({ dispatch, commit, state, getters, rootGetters }, { promoCode }) {
      commit('SET_AUTOMATIC_CODE', promoCode)
    },
    async removePromoCode ({ dispatch, commit, state, getters, rootGetters }) {
      commit('SET_COUPON_REDEEMED', false)
      commit('resetState')
      return getters.couponRedeemed
    },
    async checkPromoCode ({ dispatch, commit, state, getters, rootGetters, rootState }, { context, promoCode = null, genericToken = null, msisdn = null, skipCalculation = false }) {
      commit('errorMessage', null)
      if (typeof context !== 'undefined' && context === 'belatedMnp') {
        context = 'belatedporting'
      }
      state.promoCodeState.loading = true
      let queryDef = ''
      let variables = {}
      const provider = {
        ...rootGetters['checkout/mnpData/provider']
      }
      let network = null
      if (rootGetters['checkout/mnpData/active'] && provider.key) {
        network = {
          providerKey: provider.key,
          networkKey: provider.network
        }
      } else if (rootGetters['checkout/mnpData/active']) {
        network = {
          mnp: true
        }
      }
      const orderContext = {
        market: 'PUC'
      }
      // existing promo Code logic
      if (!promoCode) {
        promoCode = state.promoCodeState.validPromoCode
      }
      const aboOptionId = rootGetters['checkout/tariff/selectedAboOptionId']
      const tariffoptions = []
      if (aboOptionId !== null) {
        tariffoptions.push({ tariffoptionId: aboOptionId })
      }
      // existing kwk logic
      const tariffId = rootGetters['checkout/tariff/finalTariffId']
      let campaignCode = null
      campaignCode = rootGetters['kwk/campaignId']
      if (tariffId === '162' && rootGetters['kwk/kwkOrderByLink']) { // when redeeming a generic code the kwk retailer ID doesnt need to be set
        orderContext.retailerId = '30861183'
      }
      const product = {
        triggerDefault: true, // if set to true, tarifId will be set by magma
        promotions: null,
        promoCode: promoCode,
        campaignCode: campaignCode,
        genericToken,
        tariffoptions
      }
      if (context === 'checkout' || (context === 'activation' && !msisdn)) {
        context = 'checkout'
        queryDef = `query checkPromocode ($cart: CartInput!) {
          orderCart (cart: $cart) {
            targetTariff {
              baseTariffId
              basicFee
              name
              tariffId
              volumes {
                amount
                formattedUnit
                type
                unit
              }
            }
            targetTariffoptions {
              bookableTariffoptions {
                price
                name
                tariffoptionId
                volumes {
                  amount
                  formattedUnit
                  type
                  unit
                }
              }
            }
            targetPromotion {
              ...cartPromo
            }
            campaignToken
            promoCode
          }
        }`
        variables = {
          cart: {
            brand: 'simon',
            orderContext: orderContext,
            product: product,
            network: network
          }
        }
      } else if (context === 'activation') {
        queryDef = `query checkPromocode ($cart: CartInput!) {
          activationCart (cart: $cart) {
            targetPromotion {
              ...cartPromo
            }
            promoCode
            campaignToken
          }
        }`
        variables = {
          cart: {
            brand: 'simon',
            orderContext: orderContext,
            product: product,
            network: network,
            msisdn: msisdn.replace(/([^0-9])/g, '').trim()
          }
        }
      } else if (context === 'belatedporting') {
        queryDef = `query checkPromocode ($cart: CartInput!) {
          mnpInCart (cart: $cart) {
            targetTariff {
              baseTariffId
              basicFee
              name
              tariffId
              volumes {
                amount
                formattedUnit
                type
                unit
              }
            }
            targetTariffoptions {
              bookableTariffoptions {
                price
                name
                tariffoptionId
                volumes {
                  amount
                  formattedUnit
                  type
                  unit
                }
              }
            }
            targetPromotion {
              ...cartPromo
            }
            promoCode
            campaignToken
          }
        }`
        const product = {
          tariffIdentifier: tariffId,
          tariffoptions: tariffoptions,
          promoCode: genericToken, // Magma setzt genericToken für belated porting nicht um
          triggerDefault: false
        }
        variables = {
          cart: {
            orderContext: orderContext,
            product: product,
            network: {
              mnp: true,
              providerKey: provider.key,
              networkKey: provider.network
            }
          }
        }
      }
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`${queryDef}
        fragment cartPromo on BookablePromotion {
          promotionId
          name
          description
          context
          bandwidth {
            up
            down
            unit
            throttled
            throttledUnit
            tech
            formattedUnit
            formattedThrottledUnit
          }
          volumes {
            formattedUnit
            type
            amount
            unit

          }
          incentives {
            id
            title
            description
            type
            ...on ServiceIncentive {
              service
            }
            ...on CreditIncentive {
              discount
              targetId
              targetEntity
              targetFee
              creditTarget: target
            }
            ...on OtherIncentive {
              kind
            }
            ...on VolumeIncentive {
              volumeTarget: target
              amount
              unit
            }
          }
          frontendContext
          notBookableWith
          requiredParameters
          duration {
            amount
            unit
            formattedUnit
          }
          criteria {
            tariffIds
            tariffoptionIds
            mnpProvider
          }

        }`,
        variables: variables
      }).then((response) => {
        state.promoCodeState.loading = false
        let promotions = null
        let redeemedPromoCode = null
        let campaignName = ''
        if (context === 'checkout') {
          promotions = response.data.orderCart.targetPromotion || []
          promotions.map(promo => {
            if (kwkPromos.includes(promo.promotionId)) {
              promo.duration = { amount: 1, unit: 'MONTH', formattedUnit: 'Monat' }
              promo.incentives[0].targetFee = 'MONTHLY_FEE'
              promo.context = 'REGISTER_MEMBER'
              campaignName = promo.name
            }
            return promo
          })
          commit('promotion/savePresaleInclusive', { prefetchData: promotions, force: true }, { root: true })
          const redeemedCampaignToken = response.data.orderCart.campaignToken || null
          if (redeemedCampaignToken) {
            commit('kwk/setCampaignId', redeemedCampaignToken, { root: true })
            commit('kwk/setCampaignName', campaignName, { root: true })
          }
          dispatch('cart/processQueryResult', {
            tariff: response.data.orderCart.targetTariff,
            tariffoptions: response.data.orderCart.targetTariffoptions?.bookableTariffoptions || [],
            promotions: response.data.orderCart.targetPromotion
          }, { root: true }).then((result) => {
            const finalResult = result
            commit('cart/order/targetTariff', finalResult.targetTariff, { root: true })
            commit('cart/order/targetTariffoptions', finalResult.targetTariffoptions, { root: true })
            commit('cart/order/targetPromotions', finalResult.targetPromotions, { root: true })
            commit('cart/order/promoBenefits', finalResult.promoBenefits, { root: true })
          })
          redeemedPromoCode = response.data.orderCart.promoCode
        } else if (context === 'activation') {
          promotions = response.data.activationCart.targetPromotion || []
          redeemedPromoCode = response.data.activationCart.promoCode
          commit('promotion/savePresaleInclusive', { prefetchData: promotions, force: true }, { root: true })
        } else if (context === 'belatedporting') {
          promotions = response.data.mnpInCart.targetPromotion || []
          redeemedPromoCode = response.data.mnpInCart.promoCode
        }
        if (redeemedPromoCode && promotions) {
          if (Array.isArray(promotions)) {
            const voucherPromotion = promotions.filter(promo => promo.requiredParameters?.find(element => element === 'promoCode')) || null
            if (voucherPromotion) {
              commit('SET_PROMOCODE_PROMOTIONS', voucherPromotion)
              commit('SET_COUPON_REDEEMED', true)
              commit('SET_VALID_PROMOCODE', redeemedPromoCode)
            } else {
              commit('SET_COUPON_REDEEMED', false)
            }
          } else {
            commit('SET_COUPON_REDEEMED', false)
          }
        }
        return true
      }).catch((error) => {
        state.promoCodeState.loading = false
        commit('errorMessage', splitError(error)[0].message)
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        return false
      })
    },
    resetPromoCodeState ({ commit, state }) {
      commit('resetState', state)
    },
    async checkAndInitiatePromocodePromoContract ({ dispatch, commit, state, getters, rootGetters }, { promotionCode }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation checkAndInitiatePromotionBooking($input: CheckAndInitiatePromotionBookingInput!){
          checkAndInitiatePromotionBooking(checkAndInitiatePromotionBooking: $input) {
            processId
            initiatePromotionBookingUrl
            promotion {
              promotionId
              incentives {
                description
                id
              }
            }
          }
        }`,
        variables: {
          input: { promotionCode: promotionCode }
        }
      }).then((response) => {
        commit('SET_BOOKABLE_PROMOTION_DATA', response.data.checkAndInitiatePromotionBooking)
        commit('SET_VALID_PROMOCODE', promotionCode)
        commit('SET_COUPON_REDEEMED', true)
        return response.data.checkAndInitiatePromotionBooking
      }).catch((error) => {
        commit('errorMessage', splitError(error)[0].message)
        const errors = {}
        errors.errorMessage = splitError(error)[0].message
        return errors
      })
    },
    async confirmPromocodePromoContract ({ dispatch, commit, state, getters, rootGetters }, { processId }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation confirmPromotionBooking($input: ConfirmPromotionBookingInput!){
          confirmPromotionBooking(confirmPromotionBooking: $input) {
            success
          }
        }`,
        variables: {
          input: {
            processId: processId,
            consent: {
              adConsent: false,
              passData: true,
              agb: true,
              contractTermsVersion: '1.1.0'
            }
          }
        }
      }).then((response) => {
        return response.data.confirmPromotionBooking.success
      }).catch((error) => {
        commit('errorMessage', splitError(error)[0].message)
        return splitError(error)[0].message
      })
    },
    importVoucherConfigFromCto ({ dispatch, commit, state, getters, rootGetters }) {
      const config = window.$feconfig?.voucher || {}
      if (config.promotions) {
        commit('storeVoucher', config)
      }
    },
    getTextForVoucherPromo ({ dispatch, commit, state, getters, rootGetters }, { promotionId }) {
      // const config = getters.voucherConfig
      let response = null
      if (Array.isArray(getters.voucherConfig) && getters.voucherConfig.length > 1) {
        getters.voucherConfig.forEach(promotion => {
          if (promotion.id === promotionId) {
            for (const [key, value] of Object.entries(promotion)) {
              if (typeof value === 'string') {
                promotion[key] = promotion[key].replace('{', '(').replace('}', ')')
              }
            }
            response = promotion
          }
        })
        if (response) {
          return response
        } else {
          return false
        }
      }
    },
    getSlotsIdForVoucherPromo ({ dispatch, commit, state, getters, rootGetters }, { promotionId }) {
      let response = null
      if (Array.isArray(getters.voucherConfig) && getters.voucherConfig.length > 1) {
        getters.voucherConfig.forEach(promotion => {
          if (promotion.id.find(element => element === promotionId)) {
            response = promotion.slots_id
          } else {
            return null
          }
        })
        if (response) {
          return response
        } else {
          return false
        }
      }
    },
    async contractStatusAllowsRedeem ({ dispatch, commit, state, getters, rootGetters }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query {
          currentCustomerContract:
          currentCustomer {
            contract {
              state
              pauseInformation {
                nextStartDate
                bookedContractPauseInfo {
                  startDate
                  endDate
                  pauseStatus
                }
              }
            }
          },
          contractDismissal {
            contractDismissal
            possibleDismissal {
              nextPossibleDismissalDate
            }
            pendingDismissal {
              dismissalDate
            }
          }
        }`
      }).then((response) => {
        if (response.data.currentCustomerContract && response.data.contractDismissal) {
          let reply = true
          const contractDismissal = response.data.contractDismissal
          const currentCustomerContract = response.data.currentCustomerContract
          if (contractDismissal.pendingDismissal?.dismissalDate !== null && contractDismissal.contractDismissal === true && currentCustomerContract.contract?.state === 'ACTIVE') {
            reply = false
          }
          if (currentCustomerContract.contract.pauseInformation?.bookedContractPauseInfo?.pauseStatus === 'CREATED' || currentCustomerContract.contract.pauseInformation?.bookedContractPauseInfo?.pauseStatus === 'ACTIVE') {
            reply = false
          }
          if (currentCustomerContract.contract.state === 'CANCELLED' || currentCustomerContract.contract.state === 'TERMINATED_BY_SYSTEM' || currentCustomerContract.contract.state === 'DISMISSED_BY_CUSTOMER') {
            reply = false
          }
          if (currentCustomerContract.contract.state !== 'ACTIVE') {
            reply = false
          }
          return reply
          // commit('SET_ACTIVE_PROMOTIONS', response.data.activePromotions)
        } else {
          return null
        }
      }).catch((error) => {
        return splitError(error)[0].message
      })
    }
  },
  mutations: {
    SET_VALID_PROMOCODE (state, promoCode) {
      state.promoCodeState.validPromoCode = promoCode
    },
    SET_COUPON_REDEEMED (state, couponRedeemed) {
      state.promoCodeState.couponRedeemed = couponRedeemed
      state.promoCodeState.couponRedeemedContract = couponRedeemed
    },
    SET_GENERIC_CODES_REDEEMED (state, genericCodesRedeemed) {
      state.promoCodeState.genericCodesRedeemed = genericCodesRedeemed
    },
    SET_PROMOCODE_PROMOTIONS (state, allCodePromotions) {
      // Workaraound for 10%/20% Toolbox promotion
      if (allCodePromotions.length > 1 && !allCodePromotions[0].promoAdded) {
        allCodePromotions[0].incentives[0].discount += allCodePromotions[1].incentives[0].discount
        allCodePromotions[0].name += '|' + allCodePromotions[1].name
        allCodePromotions[0].promoAdded = true
      }
      const codePromotions = allCodePromotions[0]
      if (codePromotions.incentives[0].type === 'volume') {
        state.promoCodeState.couponTypeVolume = true
        state.promoCodeState.couponVolumeAmount = codePromotions.incentives[0].amount
        state.promoCodeState.couponVolumeUnit = codePromotions.incentives[0].unit
        state.promoCodeState.couponTypeCredit = false
        state.promoCodeState.couponTypeStartingBonus = false

        state.promoCodeState.voucherItem = {
          id: codePromotions.promotionId ? codePromotions.promotionId : '',
          name: codePromotions.name ? codePromotions.name : '',
          type: 'volume'
        }
      } else if (codePromotions.incentives[0].type === 'other') {
        state.promoCodeState.couponTypeVolume = false
        state.promoCodeState.couponTypeCredit = false
        state.promoCodeState.couponTypeStartingBonus = false

        state.promoCodeState.voucherItem = {
          id: codePromotions.promotionId ? codePromotions.promotionId : '',
          name: codePromotions.name ? codePromotions.name : '',
          type: 'other'
        }
      } else if (codePromotions.incentives[0].type === 'credit' && codePromotions.incentives[0].targetFee === 'MONTHLY_FEE') {
        state.promoCodeState.couponTypeCredit = true
        state.promoCodeState.couponDiscountAmount = codePromotions.incentives[0].discount
        state.promoCodeState.couponTypeVolume = false
        state.promoCodeState.couponTypeStartingBonus = false

        state.promoCodeState.voucherItem = {
          id: codePromotions.promotionId ? codePromotions.promotionId : '',
          name: codePromotions.name ? codePromotions.name.split('|')[0] : '',
          discount: codePromotions.incentives[0].discount ? codePromotions.incentives[0].discount : '',
          type: 'discount'
        }
        if (codePromotions.promoAdded) {
          state.promoCodeState.voucherItem.secondItem = {
            id: allCodePromotions[1].promotionId ? `${allCodePromotions[1].promotionId}` : '',
            name: allCodePromotions[1].name,
            type: 'discount',
            units: 1
          }
        }
      } else if (codePromotions.incentives[0].type === 'credit' && codePromotions.incentives[0].targetFee === 'ONE_TIME_FEE') {
        state.promoCodeState.couponTypeStartingBonus = true
        state.promoCodeState.couponDiscountAmount = codePromotions.incentives[0].discount
        state.promoCodeState.couponTypeVolume = false
        state.promoCodeState.couponTypeCredit = false

        state.promoCodeState.voucherItem = {
          id: codePromotions.promotionId ? codePromotions.promotionId : '',
          name: codePromotions.name ? codePromotions.name : '',
          discount: codePromotions.incentives[0].discount ? codePromotions.incentives[0].discount : '',
          type: 'discount'
        }
      }
      if (codePromotions.duration && codePromotions.duration.amount && codePromotions.duration.amount > 0) {
        state.promoCodeState.couponLimited = true
        state.promoCodeState.couponDuration = codePromotions.duration
      } else {
        state.promoCodeState.couponLimited = false
        state.promoCodeState.couponDuration = null
      }
      state.promoCodeState.codePromotions = codePromotions
    },
    SET_BOOKABLE_PROMOTION_DATA (state, bookablePromotionData) {
      state.promoCodeState.validatedBookablePromotionData = bookablePromotionData
      state.promoCodeState.validatedBookablePromotion = bookablePromotionData.promotion
    },
    resetState (state) {
      Object.assign(state.promoCodeState, initialState)
      state.activationPromoCodeAutomatic = null
    },
    errorMessage: (state, errorMessage) => {
      state.promoCodeState.errorMessage = errorMessage
    },
    setPromotCodeAutomatic (state, promoCodeAuto) {
      state.promoCodeState.promoCodeAutomatic = promoCodeAuto
    },
    storeVoucher: (state, voucher) => {
      state.voucherConfig = voucher?.promotions
      let promoIds = []
      if (Array.isArray(voucher?.promotions)) {
        voucher?.promotions.forEach(element => {
          promoIds = promoIds.concat(element.id)
        })
        state.promoIds = promoIds
      }
    },
    SET_AUTOMATIC_CODE (state, promoCode) {
      state.activationPromoCodeAutomatic = promoCode
    }
  }
}

export default PromoCodeModule
